<template >
  <section class="flex justify-center h-[352px] w-full bg-gray-100 rounded-2xl">
    <div class="relative w-full">

      <circle v-if="photos.length > 1" @click="previousSlide()" class="bg-white h-6 w-6 rounded-full absolute top-1/2 -mt-3 ml-2 z-10 cursor-pointer"><Icon class="text-primary" name="SetaEsquerda"/></circle>
      <circle v-if="photos.length > 1" @click="nextSlide()" class="bg-white h-6 w-6 rounded-full absolute top-1/2 -mt-3 mr-2 right-0 z-10 cursor-pointer" ><Icon name="SetaDireita"/></circle>

      <div class="relative overflow-hidden rounded-2xl w-full">
        <div
          v-for="(photo, key) in photos"
          :key="key"
          :ref="`slide-${key}`"
          class="h-[352px]"
          :class="photo == photos[0] ?
          'inset-0 transition-all ease-in-out duration-1000 transform translate-x-0 slide' : 'absolute inset-0 transition-all ease-in-out duration-1000 transform translate-x-full slide'"
        >
          <img
            :src="photo"
            class="h-[352px] rounded-2xl object-cover mx-auto"
            alt=""
          />
        </div>
      </div>
      <div
        v-if="photos.length > 1"
        class="bg-white absolute left-1/2 -translate-x-1/2 bottom-0 rounded-full mb-3.5"
      >
        <div class="grid grid-flow-col gap-[5px] px-[9px] py-1">
          <circle v-for="(photo, key) in photos" :key="key" class="h-2 w-2 bg-primary rounded-full dot-index"
          :ref="`dot-${key}`"
          :class="photo == photos[0] ? 'h-2 w-2 bg-primary rounded-full dot-index' : 'h-2 w-2 bg-gray-400 rounded-full dot-index'">
          </circle>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import Icon from "@/Components/UI/Icons/Icon.vue";

export default {
  components: {
    Icon,
  },
  props: {
      photos: Array
  },
  data() {
      return {
        currentSlide: this.$refs['slide-0'],
        currentDot: this.$refs['dot-0'],
      }
  },
  mounted() {
      this.currentSlide = this.$refs['slide-0']
      this.currentDot = this.$refs['dot-0']
  },
  methods: {
    nextSlide() {
      let activeSlide = this.currentSlide;
      let activeDotIndex = this.currentDot;

      if (activeSlide.nextElementSibling) {
        activeSlide.classList.remove("translate-x-0");
        activeSlide.classList.add("-translate-x-full");
        activeDotIndex.classList.remove("bg-primary");
        activeDotIndex.classList.add("bg-gray-400");

        this.currentSlide = activeSlide.nextElementSibling;
        this.currentDot = activeDotIndex.nextElementSibling;

        let nextSlide = activeSlide.nextElementSibling;
        let nextDotIndex = activeDotIndex.nextElementSibling;

        nextSlide.classList.remove("translate-x-full");
        nextSlide.classList.add("translate-x-0");
        nextDotIndex.classList.remove("bg-gray-400");
        nextDotIndex.classList.add("bg-primary");
      }
    },
    previousSlide() {
      let activeSlide = this.currentSlide;
      let activeDotIndex = this.currentDot;

      if (activeSlide.previousElementSibling) {
        activeSlide.classList.remove("translate-x-0");
        activeSlide.classList.add("translate-x-full");
        activeDotIndex.classList.remove("bg-primary");
        activeDotIndex.classList.add("bg-gray-400");

        this.currentSlide = activeSlide.previousElementSibling;
        this.currentDot = activeDotIndex.previousElementSibling;

        let previousSlide = activeSlide.previousElementSibling;
        let previousDotIndex = activeDotIndex.previousElementSibling;

        previousSlide.classList.remove("-translate-x-full");
        previousSlide.classList.add("translate-x-0");
        previousDotIndex.classList.remove("bg-gray-400");
        previousDotIndex.classList.add("bg-primary");
      }
    },
  },
};
</script>
